/**
 * Combines multiple class names into a single space-separated string.
 * Filters out falsy values (undefined, false) from the input.
 *
 * @param classes - Any number of class names as strings, or falsy values that will be filtered out
 * @returns A space-separated string of the valid class names
 *
 * @example
 * classNames('foo', 'bar') // returns 'foo bar'
 * classNames('foo', undefined, 'bar', false) // returns 'foo bar'
 * classNames() // returns ''
 */
export function classNames(
  ...classes: (string | boolean | undefined)[]
): string {
  return classes.filter(Boolean).join(" ");
}
